const CHeaderTopNavMenuSubmenuFragments = {
  field: `
  fragment submenuFragment on submenu_Entry {
    linkTitle
    linkUrl
    linkOrder
    openNewTab
  }
  `,
}

export const CHeaderTopNavMenuFragments = {
  field: `
    fragment headerTopNavMenu on headerTopNavMenu_MatrixField {
      ... on headerTopNavMenu_item_Entry {
        linkTitle
        linkUrl
        linkOrder
        openNewTab
        submenu {
          ...submenuFragment
        }
      }
    }
    ${CHeaderTopNavMenuSubmenuFragments.field}
  `,
}
